import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import apiClient from "../config/apiClient";
import API_ENDPOINTS from "../config/api";

const initialState = {
  trending_movies:         [],
  trending_movies_loading: false,
  trending_movies_error:   null,

  trending_tv_shows:         [],
  trending_tv_shows_loading: false,
  trending_tv_shows_error:   null,

  home_movies:         [],
  home_movies_loading: false,
  home_movies_error:   null,

  home_tv_shows:         [],
  home_tv_shows_loading: false,
  home_tv_shows_error:   null,
};

// ✅ Trending Movies
export const fetchTrendingMovies = createAsyncThunk(
  "home/fetchTrendingMovies",
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(API_ENDPOINTS.TRENDING_MOVIES);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

// ✅ Trending TV Shows
export const fetchTrendingTvShows = createAsyncThunk(
  "home/fetchTrendingTvShows",
  async (_, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(API_ENDPOINTS.TRENDING_TV_SHOWS);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

// ✅ Home Movies
export const fetchHomeMovies = createAsyncThunk(
  "home/fetchHomeMovies",
  async (page = 1, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(`${API_ENDPOINTS.HOME_MOVIES}?page=${page}&limit=10`);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

// ✅ Home TV Shows
export const fetchHomeTvShows = createAsyncThunk(
  "home/fetchHomeTvShows",
  async (page = 1, { rejectWithValue }) => {
    try {
      const res = await apiClient.get(`${API_ENDPOINTS.HOME_TV_SHOWS}?page=${page}&limit=10`);
      return res.data.data;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

const homeSlice = createSlice({
  name: "home",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Trending Movies
      .addCase(fetchTrendingMovies.pending, (state) => {
        state.trending_movies_loading = true;
        state.trending_movies_error   = null;
      })
      .addCase(fetchTrendingMovies.fulfilled, (state, action) => {
        state.trending_movies_loading = false;
        state.trending_movies         = action.payload;
      })
      .addCase(fetchTrendingMovies.rejected, (state, action) => {
        state.trending_movies_loading = false;
        state.trending_movies_error   = action.payload;
      })

      // Trending TV Shows
      .addCase(fetchTrendingTvShows.pending, (state) => {
        state.trending_tv_shows_loading = true;
        state.trending_tv_shows_error   = null;
      })
      .addCase(fetchTrendingTvShows.fulfilled, (state, action) => {
        state.trending_tv_shows_loading = false;
        state.trending_tv_shows         = action.payload;
      })
      .addCase(fetchTrendingTvShows.rejected, (state, action) => {
        state.trending_tv_shows_loading = false;
        state.trending_tv_shows_error   = action.payload;
      })

      // Home Movies
      .addCase(fetchHomeMovies.pending, (state) => {
        state.home_movies_loading = true;
        state.home_movies_error   = null;
      })
      .addCase(fetchHomeMovies.fulfilled, (state, action) => {
        state.home_movies_loading = false;
        state.home_movies         = action.payload;
      })
      .addCase(fetchHomeMovies.rejected, (state, action) => {
        state.home_movies_loading = false;
        state.home_movies_error   = action.payload;
      })

      // Home TV Shows
      .addCase(fetchHomeTvShows.pending, (state) => {
        state.home_tv_shows_loading = true;
        state.home_tv_shows_error   = null;
      })
      .addCase(fetchHomeTvShows.fulfilled, (state, action) => {
        state.home_tv_shows_loading = false;
        state.home_tv_shows         = action.payload;
      })
      .addCase(fetchHomeTvShows.rejected, (state, action) => {
        state.home_tv_shows_loading = false;
        state.home_tv_shows_error   = action.payload;
      });
  },
});

export default homeSlice.reducer;
